import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_JOBS_URL;

// eslint-disable-next-line max-len
const handleError = (error: any, defaultMessage: string) => error.response?.data?.error || defaultMessage;

export const fetchRatings = createAsyncThunk(
  'ratings/fetchRatings',
  async (
    {
      token,
      userId,
      jobId,
    }: { token: string; userId: string; jobId: string | null },
    { rejectWithValue },
  ) => {
    if (!userId || typeof userId !== 'string') {
      return rejectWithValue('Invalid userId');
    }

    try {
      const { data } = await axios.get(
        `${API_BASE_URL}/rating/ratings/${userId}`,
        {
          params: { jobId },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return data.ratings;
    } catch (error) {
      return rejectWithValue(handleError(error, 'Error fetching ratings'));
    }
  },
);

export const fetchAverageRating = createAsyncThunk(
  'ratings/fetchAverageRating',
  async (
    {
      token,
      userId,
      jobId,
    }: { token: string; userId: string; jobId: string | null },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios.get(
        `${API_BASE_URL}/rating/ratings/${userId}/average`,
        {
          params: { jobId },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return data;
    } catch (error) {
      return rejectWithValue(
        handleError(error, 'Error fetching average rating'),
      );
    }
  },
);

export const addRating = createAsyncThunk(
  'ratings/addRating',
  async (
    {
      token,
      userId,
      jobId,
      raterId,
      raterName,
      rating,
      description,
    }: {
      token: string;
      userId: string;
      jobId: string;
      raterId: string;
      raterName: string;
      rating: number;
      description: string;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios.post(
        `${API_BASE_URL}/rating/ratings`,
        {
          userId,
          jobId,
          raterId,
          raterName,
          rating,
          description,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return data.rating;
    } catch (error) {
      return rejectWithValue(handleError(error, 'Error adding rating'));
    }
  },
);
